import React from 'react';


import { makeStyles } from '@material-ui/styles';
import Box from '@material-ui/core/Box';
import { Grid, Typography } from '@material-ui/core';
import { useImagePath } from '../hooks/paths';

const useStyles = makeStyles((theme) => ({

  root: {
    display: 'flex',
    justifyContent: 'center',
    // backgroundColor:'red'
  },

  featuredRow: {
    width: "100%",
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },

  featured: {
    width: "100%",
    margin: theme.spacing(1, 2, 0, 2),
    [theme.breakpoints.up('md')]: {
      width: "80%",
      margin: theme.spacing(3),
    },
  },

  filterBottom: {
    position: 'relative',
    boxShadow: 'none',
    borderRadius: 0,

    '&:after': {
      content: '""',
      display: 'block',
      position: 'absolute',
      width: '100%',
      height: '40%',
      bottom: 6,
      zIndex: 1,
      background: 'linear-gradient(to top, rgba(0,0,0,0.8),rgba(0,0,0,0.5),rgba(0,0,0,0.2),rgba(0,0,0,0.0))',
      borderRadius: '0 0 16px 16px',
      boxShadow: theme.boxShadow.image
    },
  },

  filterTop: {
    position: 'relative',
    boxShadow: 'none',
    borderRadius: 0,

    '&:after': {
      content: '""',
      display: 'block',
      position: 'absolute',
      width: '100%',
      height: '40%',
      top: 0,
      zIndex: 1,
      background: 'linear-gradient(to bottom, rgba(0,0,0,0.8),rgba(0,0,0,0.5),rgba(0,0,0,0.2),rgba(0,0,0,0.0))',
      borderRadius: '16px 16px 0 0',
      //boxShadow: theme.boxShadow.image
    },
  },

  notFilter: {

  },

  image: {
    width: "100%",
    height: 'auto',
    borderRadius: 16,
    boxShadow: theme.boxShadow.image,
  },

  bottomGravity: {
    position: 'absolute',
    zIndex: 2,
    bottom: 0,
    width: '100%',
    [theme.breakpoints.up('md')]: {
      margin: theme.spacing(2),
    },
  },

  topGravity: {
    position: 'absolute',
    zIndex: 2,
    top: 0,
    width: '100%',
    [theme.breakpoints.up('md')]: {
      margin: theme.spacing(2),
    },
  },

  boxTitle: {
    textTransform: 'uppercase',
    fontSize: '2.7rem',
    [theme.breakpoints.up('md')]: {
      padding:theme.spacing(0,3,0,0),
    },
  },
  subtitle: {
    textTransform: 'capitalize',
    [theme.breakpoints.up('md')]: {
      padding: theme.spacing(0,3,0,0),
    },
  }

}));


export default function FeaturedCard(props) {
  const classes = useStyles();
  const { title, subtitle, image, textAlign, features } = props
  const imagePath = useImagePath();
  const featureUrl = `${imagePath}/feature_default_1024x512.jpg`;


  const getGravityClass = (textAlign, title, subtitle) => {
    if ((!title || title == "") && (!subtitle || subtitle))
      return {
        box: undefined,
        filter: classes.notFilter
      }

    let gravity = classes.buttomGravity;
    if (textAlign.includes('top')) {
      gravity = {
        box: classes.topGravity,
        filter: classes.filterTop
      }
    } else if (textAlign.includes('bottom')) {
      gravity = {
        box: classes.bottomGravity,
        filter: classes.filterBottom
      }
    } else {
      gravity = {
        box: classes.bottomGravity,
        filter: classes.filterBottom
      }
    }
    return gravity;
  };

  const getAlingClass = (textAlign) => {
    let aling = 'left'
    if(!textAlign) return aling; 

    if (textAlign.includes('start')) {
      aling = 'left'
    } else if (textAlign.includes('end')) {
      aling = 'right'
    }
    return aling
  };

  const gravity = getGravityClass(textAlign, title, subtitle);
  const aling = getAlingClass(textAlign);

  //console.log('gravity:', gravity.box);
  //console.log('title:', title);
  //console.log('subtitle:', subtitle);
  
  return (
    <div className={classes.root}>
      <Grid item xs={12} sm={7} >
        <div className={classes.featuredRow}>
          <div className={classes.featured}>
            <div className={gravity.filter}>


              <img className={classes.image} src={image ? image : featureUrl} alt={"image"} />


              {gravity.box &&
                <Box py={1} px={2} className={gravity.box}>
                  <Typography
                    variant='h5'
                    className={classes.boxTitle}
                    color='primary'
                    align={aling}
                  >
                    {title}
                  </Typography>

                  <Typography
                    variant="body1"
                    className={classes.subtitle}
                    color='primary'
                    align={aling}
                  >
                    {subtitle}
                  </Typography>
                </Box>
              }

            </div>

          </div>
        </div>
      </Grid>
    </div>
  )
}